/* app/js/src/components/monitoring/status/monitoring-status.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.evrideo-monitoring-chart {
  width: 90%;
  height: 100%;
}
.y-label {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
}
.refresh {
  width: 31px;
  display: inline-block;
  line-height: 40px;
  border-radius: 3px;
  transform: scale(2, 2);
  text-align: center;
  cursor: pointer;
}
.refresh:hover {
  transform: scale(2.1, 2.1);
}
.container .body {
  text-align: center;
  width: 80%;
  height: 100%;
  margin-top: 1vh;
}
.container .body h1 {
  display: inline-block;
}
.container .az-table {
  margin-left: 30px;
}
.container .az-table tbody td {
  cursor: pointer;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-right: 5px;
  padding-left: 5px;
}
.container .az-table tbody td input {
  cursor: pointer;
}
.container .status {
  display: inline-block;
  width: 24px;
  height: 24px;
  color: white;
  border-radius: 12px;
  text-align: center;
  background-color: #ec322f;
}
.container .status.online {
  background-color: #119e11;
}
/*# sourceMappingURL=monitoring-status.component.css.map */
